module.exports = __webpack_public_path__ + "img/yellow-lily.7cbe9c51.jpg";